import { z, zv } from '@faceup/validation'

export const memberSchema = z.object({
  id: z.uuidv7(),
  name: z.string().nullable(),
  email: zv.email().nullable(),
  profileImageUrl: zv.url().nullable(),
})
